<template>
	<section class="menu-section">
		<div class="row row-header">
			<div class="columns column12 align-center">
				<picture>
					<source :srcset="imageWebp" type="image/webp" />
					<source :srcset="image" />
					<img :src="image" :alt="imageAlt" class="icon-image fade-animate fade-up" loading="lazy" />
				</picture>
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
		</div>
		<div class="row">
			<div class="columns column12 menu-row">
				<div v-for="item in items.slice(0, 3)" :key="item.ID" class="menu-item">
					<div class="image-holder">
						<nuxt-link :to="localePath('menu') + `#menu-` + item.ID">
							<div class="image">
								<picture>
									<source :srcset="item.overviewImageWebp" type="image/webp" />
									<source :srcset="item.overviewImage" />
									<img :src="item.overviewImage" :alt="item.overviewImageAlt" loading="lazy" />
								</picture>
							</div>
							<div class="content">
								<div v-parse-links v-html="item.content" />
								<h4>{{ item.header }}</h4>
							</div>
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.menu-section {
	.row-filter {
		flex-flow: row wrap;
		align-items: flex-start;
	}

	h3 {
		font-family: var(--body-font-family);
		margin: 0 0 20px;
		max-width: 300px;
		color: var(--header-color-secondary);
	}

	a {
		color: var(--body-color);
		text-decoration: none;
		text-transform: uppercase;
	}

	.content {
		text-align: left;
		padding: 10px 0;
	}

	.row {
		max-width: 1400px;
	}

	.menu-row {
		display: flex;
		flex-flow: row wrap;
		place-content: center center;
		gap: 40px;
		margin-top: 25px;

		:deep(p) {
			margin: 10px 0 0;
		}
	}
}

.image-holder {
	position: relative;
	padding: 0;
	width: 100%;

	a {
		z-index: 1;
		position: relative;
		text-decoration: none;

		img {
			transition: opacity 0.4s ease;
			aspect-ratio: 68 / 102;
		}

		&:hover img {
			opacity: 0.8;
		}

		&::after {
			display: none;
		}
	}
}

.menu-item {
	width: 30%;
	padding: 0;
	flex-flow: column wrap;
	position: relative;
	justify-content: flex-start;
	align-items: flex-start;

	.image {
		width: 100%;

		img {
			clip-path: polygon(50% 13%, 100% 30%, 100% 100%, 0% 100%, 0% 30%);
			overflow: hidden;
		}
	}

	h4 {
		font-family: var(--body-font-family);
		margin: 0;
		color: var(--body-color);
		font-weight: 800;
	}

	p {
		font-family: var(--body-font-family);
		color: var(--body-color);
		margin: 0;
		font-weight: 500;
		text-transform: none;
	}
}

@supports (-webkit-mask-image: url('#mask')) or (mask-image: url('#mask')) {
	.menu-item {
		.image {
			img {
				clip-path: none;
				mask-image: url('~/assets/images/rooms-shape-mask.png');
				mask-size: 100%;
			}
		}
	}
}

@media (max-width: 880px) {
	.menu-section {
		.menu-item {
			width: 88%;
			max-width: 400px;
			margin: 20px auto;
			padding: 0 2px;
		}

		h3 {
			margin: 0 auto 20px;
		}
	}
}
</style>
